import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getInsightsList } from "../data/insightsData.js";

const DEFAULT_TITLE = (
  <>
    Unsere Erkenntnisse zu Kostenträgern,
    <br className="hidden md:block" />
    Anbietern, Systemen und Dienstleistungen im Gesundheitswesen
  </>
);

export default function InsightsSection({
  basePath = "/medical",
  sectionTitle = DEFAULT_TITLE,
}) {
  const insightsList = getInsightsList(basePath);
  const normalizedBasePath = basePath.replace(/\/$/, "");
  const isMedicalHome = normalizedBasePath === "/medical";

  const INSIGHTS = isMedicalHome
    ? ["chefarzt-rekrutierung", "direktansprache", "digital-future"]
        .map((slug) => insightsList.find((item) => item.slug === slug))
        .filter(Boolean)
    : insightsList.slice(0, 3);
  const moreLinkPath = `${basePath.replace(/\/$/, "")}/insights`;

  return (
    <section className="bg-white py-12">
      <div className="mx-auto container-app">
        {/* Heading */}
        <h2 className="text-xl sm:text-3xl md:text-4xl font-semibold md:font-medium text-gray-900">
          {sectionTitle}
        </h2>
       
       
        

        {/* Cards: horizontal slider on mobile, grid from md */}
        <div
          className="mt-10 flex overflow-x-auto overflow-y-hidden snap-x snap-mandatory gap-4 pb-2 -mx-4 px-4 md:mx-0 md:px-0 md:grid md:overflow-visible md:snap-none md:gap-6 md:grid-cols-3"
          style={{ WebkitOverflowScrolling: "touch" }}
        >
          {INSIGHTS.map((item) => (
            <Link
              key={item.id}
              to={item.to}
              className="group relative h-[460px] overflow-hidden rounded-[16px] shadow-[0_18px_40px_rgba(0,0,0,0.18)] flex-none w-[85%] min-w-[85%] snap-center md:flex-initial md:w-auto md:min-w-0"
            >
              {/* Image */}
              <img
                src={item.image}
                alt={`${item.title} - ${item.topic}`}
                className="absolute inset-0 h-full w-full object-cover transition duration-700 ease-out group-hover:scale-[1.04]"
              />

              {/* Top pill */}
              <div className="absolute left-6 top-6 z-10">
                  <span className="inline-flex items-center rounded-full bg-neutral-900/70 px-5 py-2 text-[11px] font-semibold tracking-[0.08em] text-white backdrop-blur-sm">
                  {item.topic}
                </span>
              </div>

              {/* Sliding Glass Card */}
              <div
                className="
    absolute left-6 right-6 bottom-10
  "
              >
                <div
                  className="
      rounded-[18px] bg-white/85 backdrop-blur-md
      shadow-[0_20px_60px_rgba(0,0,0,0.22)]
      overflow-hidden
      transition-all duration-700
      ease-[cubic-bezier(0.22,1,0.36,1)]
      h-auto min-h-0 md:h-[170px] md:group-hover:h-[360px]
    "
                >
                  <div className="p-6">
                    <div className="flex items-center gap-3 text-[10px] font-semibold tracking-[0.18em] text-neutral-800/80">
                      <span>{item.type}</span>
                      <span className="h-[1px] w-3 bg-neutral-800/35" />
                      <span>{item.date}</span>
                    </div>

                    <div className="mt-4 whitespace-pre-line text-[22px] leading-[1.1] tracking-[-0.01em] text-neutral-900 sm:text-[24px]">
                      {item.title}
                    </div>

                    {/* Description: hidden on mobile; on desktop shown on hover */}
                    <div className="mt-4 transition-opacity duration-500 delay-200 md:opacity-0 md:group-hover:opacity-100">
                      <p className="text-[14px] leading-6 text-neutral-700 hidden md:block">
                        {item.description}
                      </p>

                      <div className="mt-6 flex justify-end">
                        <span className="group/btn btn btn-bg mt-auto text-gray-900">
                          Mehr erfahren <ArrowRight className="h-5 w-6 shrink-0 transition-transform duration-200 ease-out group-hover/btn:translate-x-0.5" aria-hidden />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* subtle overlay: only on desktop hover */}
              <div className="absolute inset-0 bg-black/0 transition duration-500 md:group-hover:bg-black/10" />
            </Link>
          ))}
        </div>
        <div className="mt-16">
          <Link
            to={moreLinkPath}
            className="group btn btn-outline text-xs uppercase tracking-[0.12em]"
          >
            Mehr Einblicke
            <ArrowRight className="h-5 w-6 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-0.5" aria-hidden />
          </Link>
        </div>
      
      </div>
    
    </section>
  );
}
